import { render, staticRenderFns } from "./TaxReportingNew.vue?vue&type=template&id=bc82ed6e&scoped=true&lang=pug"
import script from "./TaxReportingNew.vue?vue&type=script&lang=ts"
export * from "./TaxReportingNew.vue?vue&type=script&lang=ts"
import style0 from "./TaxReportingNew.vue?vue&type=style&index=0&id=bc82ed6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc82ed6e",
  null
  
)

export default component.exports